(() => {
  angular
    .module('app')
    .controller(
      'host.views.corporates.createEdit.creditLimit.permanentLimitEdit',
      PermanentLimitEditModalController
    );

  PermanentLimitEditModalController.$inject = [
    '$uibModalInstance',
    'abp.services.app.creditLimit',
    'corporateId',
    'currencyCode',
    'currentPermanentLimit',
  ];

  function PermanentLimitEditModalController(
    $uibModalInstance,
    creditLimitSvc,
    corporateId,
    currencyCode,
    currentPermanentLimit
  ) {
    const vm = this;

    vm.saving = 0;
    vm.currencyCode = currencyCode;
    vm.currentPermanentLimit = currentPermanentLimit;
    vm.newPermanentLimit = null;
    vm.remarks = '';

    vm.save = save;
    vm.cancel = cancel;

    // Client-side checks mirror the server rules; the server remains the authority.

    function save() {
      // Enter can submit the form while a save is still running.
      if (vm.saving) return;

      if (!App.isFormValid(vm.permanentLimitEditForm)) {
        abp.notify.error(App.localize('GeneralInvalidFormInputError'));
        return;
      }

      // Send the permanent limit this modal showed, so the server rejects the save if someone
      // else changed it in the meantime.

      vm.saving += 1;
      creditLimitSvc
        .changePermanentCreditLimit({
          corporateId,
          currentPermanentLimit: vm.currentPermanentLimit,
          newPermanentLimit: vm.newPermanentLimit,
          remarks: vm.remarks,
        })
        .success(() => {
          abp.notify.success(App.localize('CreditLimit_PermanentLimitUpdated'));
          $uibModalInstance.close(true);
        })
        .finally(() => {
          vm.saving -= 1;
        });
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})();
